import { render, staticRenderFns } from "./AddPlaylistForm.vue?vue&type=template&id=4807c342&scoped=true&"
import script from "./AddPlaylistForm.vue?vue&type=script&lang=js&"
export * from "./AddPlaylistForm.vue?vue&type=script&lang=js&"
import style0 from "./AddPlaylistForm.vue?vue&type=style&index=0&id=4807c342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4807c342",
  null
  
)

export default component.exports